export default {
  INTEGRATION: "IC.Testing.FeatureFlagsIntegrationTest",
  MINIMAP: "IC.WebClient.CaseCreationMapInput",
  NOTIFICATIONS: "IC.WebClient.InfoRequestsRealTimeNotifications",
  SUBMIT_CONTACT: "IC.WebClient.CaseSubmitContactPreferences",
  STATEMENTS: "IC.Cases.Statements"
};
